import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-teal-700/30 bg-zinc-900 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-77" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-78" data-mp="9t1ptdkbepep">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-teal-700 bg-zinc-950 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-79" data-mp="etplicjhnuf9">
          <span className="inline-flex rounded-full border border-teal-400/50 bg-zinc-900 p-4 text-teal-400" data-id="element-80" data-mp="sn6w37u75wt5">
            <ShieldCheckIcon className="h-10 w-10 drop-shadow-[0_0_6px_rgba(45,212,191,0.55)]" aria-hidden="true" data-id="element-81" data-mp="12j0idixpx4o4" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-82" data-mp="17hbtdwzr1l7x">
            7-Day <span className="text-orange-400" data-id="element-83" data-mp="25t8d8o72w3qm">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-zinc-300" data-id="element-84" data-mp="20rspgodinj4j">
            Study all 6 volumes and 5 bonuses this week. If the technical depth doesn&apos;t match what you need in the
            boiler room,{' '}
            <span className="font-extrabold text-orange-400" data-id="element-85" data-mp="1rtqmi3a82gem">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}